// What removing a person will do, spelled out for the confirmation dialog.
// The server (functions/lib/userDeletion.js) is what actually does it; these
// lines only describe it, from the data getAuthUser returned. Each line is an
// i18n key under `users.delete.lines` plus its variables.

/**
 * @param {{videos: Array<{total: number}>}} user
 * @returns {{videos: number, events: number}}
 */
export function videoTotals(user) {
  const rows = user.videos || []
  return { videos: rows.reduce((n, r) => n + r.total, 0), events: rows.length }
}

/**
 * @param {object} user The getAuthUser result.
 * @param {'access'|'account'|'everything'} mode
 * @returns {{removed: Array<{key: string, vars?: object}>, kept: Array<{key: string, vars?: object}>}}
 */
export function deletionLines(user, mode) {
  const removed = []
  const kept = []
  const roleCount = (user.eventRoles || []).length
  const totals = videoTotals(user)

  if (roleCount > 0) removed.push({ key: 'eventRoles', vars: { count: roleCount } })
  if (user.sysadmin) removed.push({ key: 'sysadmin' })
  if (user.salesRole) removed.push({ key: 'salesAccess' })
  if (user.profile) removed.push({ key: 'profile' })

  if (mode === 'access') kept.push({ key: 'login' })
  else removed.push({ key: 'login' })

  if (totals.videos > 0) {
    if (mode === 'everything') removed.push({ key: 'videos', vars: totals })
    else kept.push({ key: 'videos', vars: totals })
  }

  if (user.sales) kept.push({ key: 'salesRecord' })
  kept.push({ key: 'eventContent' })
  return { removed, kept }
}

/**
 * What must be typed to confirm: the email, or the uid of an account with none.
 * @param {{uid: string, email: ?string}} user
 * @returns {string}
 */
export function confirmTarget(user) {
  return user.email || user.uid
}

/**
 * @param {{uid: string, email: ?string}} user
 * @param {string} typed
 * @returns {boolean}
 */
export function confirmMatches(user, typed) {
  const entry = (typed || '').trim()
  if (!entry) return false
  if (user.email) return entry.toLowerCase() === user.email.toLowerCase()
  return entry === user.uid
}
